/**
 * AuthInitializer Component
 * Runs once at app level to initialize auth state from localStorage
 * and refresh user data from the backend. This avoids redundant
 * getCurrentUser() calls that previously happened on every route change.
 */

import { useEffect, useRef } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { authService } from '@/services/api/auth';

export function AuthInitializer() {
  const hasRefreshed = useRef(false);

  useEffect(() => {
    if (hasRefreshed.current) return;

    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return;

    hasRefreshed.current = true;

    const { initializeFromStorage, setUser, logout } = useAuthStore.getState();
    initializeFromStorage();

    authService.getCurrentUser().then(setUser).catch(() => {
      logout();
      window.location.href = '/login?sessionExpired=true';
    });
  }, []);

  return null;
}
